const SET_QAB_UPLOADED_BUTTON = 'SET_QAB_UPLOADED_BUTTON';
const DISABLE_MOBILE_QAB = 'DISABLE_MOBILE_QAB';

export { SET_QAB_UPLOADED_BUTTON, DISABLE_MOBILE_QAB };
